import { render, staticRenderFns } from "./ReservationForm.vue?vue&type=template&id=52f84b5b&scoped=true&"
import script from "./ReservationForm.vue?vue&type=script&lang=js&"
export * from "./ReservationForm.vue?vue&type=script&lang=js&"
import style0 from "./ReservationForm.vue?vue&type=style&index=0&id=52f84b5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f84b5b",
  null
  
)

export default component.exports